import React from 'react';
import { Redirect } from 'react-router-dom';
import { defaultMerchant } from '../constants/SiteVariables';

export default function Index() {
  const defaultMerchantPublicKey = defaultMerchant();

  return (
    <Redirect to={`/pdp/${defaultMerchantPublicKey}/pdp/0,0,0,0`} />
  );
}
